<template>
    <section class="section-hero section-shaped my-0">
        <div class="shape shape-style-1 shape-dark">
            <span class="span-150"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-25"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-25"></span>
            <span class="span-50"></span>
            <span class="span-59"></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center pt-lg">
                        <h1 class="text-white">404 ERROR</h1>
                        <p class="lead text-white mt-4 mb-5">That page does not exist...</p>
                    </div>
                </div>
                <div class="row align-items-center justify-content-around stars-and-coded">
                    <!-- empty -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "NotFound",
    }
</script>